import { Box, Text } from "@prismicio/editor-ui"
import type { PropsWithChildren, ReactNode } from "react"

type SettingsPageBodyHeaderProps = PropsWithChildren<{
  title: ReactNode
  description: ReactNode
}>

export function SettingsPageBodyHeader(props: SettingsPageBodyHeaderProps) {
  const { title, description, children } = props
  return (
    <Box gap={80}>
      <Box
        flexDirection="column"
        flexGrow={children ? undefined : 1}
        gap={8}
        width={335}
      >
        <Text variant="h3">{title}</Text>
        <Text color="grey11">{description}</Text>
      </Box>
      {children && (
        <Box flexDirection="column" flexGrow={1} flexBasis={0}>
          {children}
        </Box>
      )}
    </Box>
  )
}
